/**
 * Verify user screen
 * Verify user email after signup
 * After successful verification the user is logged in automatically and redirected to the create profile screen
 */
import React from "react"
import { ThemeProvider } from "styled-components"
import theme from "styles/theme-main"
import Recaptcha from "react-google-invisible-recaptcha"
import { Helmet } from "react-helmet-async"
import { createTheme, MuiThemeProvider } from "@material-ui/core/styles"
import PreviewModeBanner from "components/PreviewModeBanner"
import ReactGA from "utils/GA"
import ReactPixel from "react-facebook-pixel"
import Translate from "components/Translate/container"
import { getDateTimeWithUTCOffset } from "utils/rolesUtils"
import {
  FormWrapper,
  FormHeader,
  FormRow,
  FormRowFooter,
  FormFooter,
  TwoUpWrapper,
  TitleWrapper,
  TitleText,
  Wrapper,
  Divider,
  DataRow,
  DataItem,
  Overview,
  OverviewButtonContainer,
  DownloadItem,
  DeadlineWrapper,
} from "./styles"
import InputField from "components/InputField"
import Button from "components/Button"
import AppLoader from "components/AppLoader"
import ErrorModal from "components/ErrorModal"
import TextButton from "components/TextButton"
import ReportIssue from "../../components/ReportIssue"
import CheckboxField from "components/CheckboxField"
import TooltipInternational from "components/TooltipInternational"
import Text from "components/Text"
import {
  getQueryParameters,
  isCandidate,
  isCRSAOOrganization,
  convertMUI,
  isEmail,
  isPassword,
  shouldNotHideItem,
  isHRDisabled,
} from "utils/utils"
import {
  isFBTracker,
  isNonLegalClient,
  getAccountType,
  getLanguageSupported,
} from "utils/clientUtils"
import { profileUrl } from "utils/config"
import {
  isHRPath,
  isProfileMode,
  isInternalMode,
  isLateralMode,
} from "utils/productUtils"
import {
  getFormConfigurationFromRole,
  getFormConfigurationFromOrganization,
} from "utils/configUtils"
import { getRole, signUp as apiSignUp } from "services/public"
import {
  NO_CRAWL_URLS,
  RECAPTCHA_SITEKEY,
  RECAPTCHA_BYPASS_PARAM,
  ENGLISH_LANGUAGE_CODE,
  ENGLISH_LANGUAGE_NAME,
} from "utils/constants"
import { translateText } from "utils/languageUtils"
export class AnonymousApplyPortal extends React.Component {
  constructor(props) {
    super(props)

    this.recaptchaBypassToken = false

    this.state = {
      robotAccepted: false,
      email: null,
      password: null,
      loading: false,
      selectedTabIndex: 1,
      infoLoading: true,
      loginRegister: false,
    }
    this.recaptcha = React.createRef()
  }

  handleChange = ev => {
    this.setState({ [ev.target.id]: ev.target.value })
  }

  goToForgotPassword = () => {
    const configuration = getFormConfigurationFromOrganization(
      this.props.organization
    )
    if (
      isHRDisabled(configuration, "useVantageForForgot") ||
      isNonLegalClient(this.props.organization)
    ) {
      this.props.history.push(`/forgot-password`)
    } else {
      window.location.href = `${profileUrl}/forgot-password`
    }
  }

  handleCheckboxChange = (id, value) => {
    this.setState({
      [id]: value,
    })
  }

  checkAtsEnabled = props => {
    const query = getQueryParameters(this.props.location)
    getRole(props.organization.id, props.match.params.roleId)
      .then(response => {
        if (response.data) {
          const role = response.data
          const overview =
            role.languageFields?.find(l => l.languageCode === query.language)
              ?.description || role.description
          const isRoleClosed =
            role.status === "ARCHIVED" ||
            (role.roleDeadline && role.roleDeadline < new Date().getTime())

          if (isCRSAOOrganization(props.organization)) {
            if (!overview || query.login) {
              this.continueAsGuest()
            } else {
              this.setState({
                role,
                selectedTabIndex: 0,
                infoLoading: false,
                overview,
                errorModalOpen: isRoleClosed,
              })
            }
          } else {
            if (isCandidate(props.user) && (!overview || query.login)) {
              //login automatically
              props.history.push({
                pathname: `/applya/${props.match.params.roleId}`,
                search: window.location.search,
              })
            } else {
              this.setState({
                role: response.data,
                selectedTabIndex: overview && !query.login ? 0 : 1,
                infoLoading: false,
                overview,
                errorModalOpen: isRoleClosed,
              })
            }
          }
        } else {
          this.setState({
            errorModalOpen: true,
            infoLoading: false,
          })
        }
      })
      .catch(() => {
        this.setState({
          errorModalOpen: true,
          infoLoading: false,
        })
      })
  }

  componentWillUpdate(nextProps) {
    if (
      !this.props.user.loading &&
      !this.props.organization &&
      nextProps.organization
    ) {
      this.checkAtsEnabled(nextProps)
      const tracker = isFBTracker(nextProps.organization)
      if (tracker) {
        ReactPixel.init(tracker)
        ReactPixel.pageView()
      }
    }
    if (
      this.props.organization &&
      this.props.user.loading &&
      !nextProps.user.loading
    ) {
      this.checkAtsEnabled(nextProps)
    }
    if (
      !this.props.account.isLoggedIn &&
      nextProps.account.isLoggedIn &&
      this.state.loginRegister
    ) {
      this.props.history.push({
        pathname: `/applya/${this.props.match.params.roleId}`,
        search: window.location.search,
      })
    }
  }

  componentDidMount() {
    ReactGA.event({
      category: "Candidate Metrics",
      action: "Roles - Login/sign up page",
      label: "Roles - Login/sign up page",
      value: 1,
    })

    const tracker = isFBTracker(this.props.organization)
    if (tracker) {
      ReactPixel.init(tracker)
      ReactPixel.pageView()
    }
    if (this.props.organization && !this.props.user.loading) {
      this.checkAtsEnabled(this.props)
    }
    const query = getQueryParameters(this.props.location)
    if (query.utm_campaign) {
      this.setState({ referral: query.utm_campaign })
    }
  }

  continueAsGuest = () => {
    this.props.history.push({
      pathname: `/applya/${this.props.match.params.roleId}`,
      search: window.location.search,
    })
  }

  loginAction = ev => {
    if (ev) ev.preventDefault()

    ReactGA.event({
      category: "Candidate Metrics",
      action: "Roles - login",
      label: "Roles - login",
      value: 1,
    })

    const { email, password } = this.state
    const { login, organization } = this.props

    this.setState({
      loading: true,
      loginRegister: true,
    })

    login(email, password, organization.id)
  }

  signupAction = ev => {
    let useRecaptcha = true
    if (window.location.search) {
      const query = getQueryParameters(window.location)
      if (query[RECAPTCHA_BYPASS_PARAM]) {
        this.recaptchaBypassToken = query[RECAPTCHA_BYPASS_PARAM]
        useRecaptcha = false
      }
    }
    if (useRecaptcha || this.state.capchaResolved) {
      this.recaptcha.execute()
    } else {
      this.onResolved()
    }
  }

  onResolved = () => {
    const { firstName, lastName, remail, rpassword, referral } = this.state
    const { processFailure, login, organization } = this.props
    this.setState({
      loading: true,
      loginRegister: true,
      capchaResolved: true,
    })

    const recaptchaToken =
      this.recaptchaBypassToken || this.recaptcha.getResponse()

    if (this.recaptcha) {
      this.recaptcha.reset()
    }

    apiSignUp({
      firstName,
      lastName,
      email: remail,
      password: rpassword,
      referral,
      passport: true,
      recaptchaToken,
    })
      .then(res => {
        ReactGA.event({
          category: "Candidate Metrics",
          action: "Roles - create new account",
          label: "Roles - create new account",
          value: 1,
        })
        login(res.data.email, rpassword, organization.id)
        this.setState({
          loading: false,
        })
      })
      .catch(err => {
        this.setState({
          loading: false,
        })
        processFailure({ type: "signup", message: err })
      })
  }

  handleTabChange = (ev, index) => {
    if (isCRSAOOrganization(this.props.organization)) {
      this.continueAsGuest()
    } else {
      if (this.props.account.isLoggedIn) {
        this.props.history.push({
          pathname: `/applya/${this.props.match.params.roleId}`,
          search: window.location.search,
        })
      } else {
        this.setState({ selectedTabIndex: index })
      }
    }
  }

  closeErrorModal = () => {
    this.props.history.push({ pathname: "/roles" })
  }
  render() {
    const {
      email,
      password,
      rpassword,
      remail,
      rcpassword,
      agreeToTerms,
      role,
      infoLoading,
      selectedTabIndex,
      overview,
    } = this.state

    const { loading, organization, location, translationMap } = this.props

    const queryParams = new URLSearchParams(location.search)
    const isPreviewMode = queryParams.get("preview")

    if (organization) {
      const orgtheme = JSON.parse(organization.themeConfiguration || "{}")
      theme.logoWidth = orgtheme.logoWidth
      theme.logoMargin = orgtheme.logoMargin
      if (orgtheme.headerBGcolour) {
        theme.colors.headerBGcolour = orgtheme.headerBGcolour
      } else {
        theme.colors.headerBGcolour = "#ffffff"
      }
      theme.typography.fonts.regular = "Europa"
      theme.colors.primary = orgtheme.secondary || theme.colors.secondary
      theme.colors.secondary = orgtheme.secondary || theme.colors.secondary
      theme.menuItems.active = theme.colors.secondary
      theme.menuItems.selected = theme.colors.secondary
      theme.buttons.primary.background = theme.colors.secondary
      if (isHRPath()) {
        document.title = `${organization.name} | Apply`
      }
    }
    const muitheme = createTheme(convertMUI(theme))

    const missingLoginEmail = !email
    const invalidLoginEmail = !isEmail(email)

    const missingLoginPassword = !password
    const errorLoginBoolean =
      missingLoginEmail || invalidLoginEmail || missingLoginPassword

    const missingRegisterEmail = !remail
    const invalidRegisterEmail = !isEmail(remail)

    const missingRegisterPassword = !rpassword
    const invalidRegisterPassword = !isPassword(rpassword)
    const missingAgree = !agreeToTerms
    const missingConfirmPassword = !rcpassword
    const noneMatchingPasswords = rpassword !== rcpassword
    const errorRegisterBoolean =
      missingRegisterEmail ||
      invalidRegisterEmail ||
      missingRegisterPassword ||
      invalidRegisterPassword ||
      missingAgree ||
      noneMatchingPasswords ||
      missingConfirmPassword

    const accountType = getAccountType(organization)

    let headerCreate = `Create a ${accountType} account`
    let headerLogin = isNonLegalClient(organization)
      ? `Login using your Candid details`
      : `Apply faster with ${accountType}`
    let agreeTerms = (
      <span>
        {translateText(translationMap, `I agree to ${accountType}`)}{" "}
        <a
          href="https://www.vantageapp.io/terms-of-use.html"
          target="_blank"
          rel="noopener noreferrer"
        >
          {translateText(translationMap, `Terms of Use`)}
        </a>{" "}
        {translateText(translationMap, `and`)}{" "}
        <a
          href="https://www.vantageapp.io/privacy-policy.html"
          target="_blank"
          rel="noopener noreferrer"
        >
          {translateText(translationMap, `Privacy Policy`)}
        </a>
        .
      </span>
    )

    let showRegister = true
    let showDepartment = true
    let showApplicationDeadlineInOverview = true
    if (organization) {
      const configuration = getFormConfigurationFromOrganization(organization)
      showRegister = shouldNotHideItem(configuration, "register")
      showDepartment = shouldNotHideItem(configuration, "departments")
      if (isInternalMode()) {
        headerCreate = `Create your Rare account`
        headerLogin = `Login using your Rare details`
        agreeTerms = (
          <p>
            I agree to Rare's{" "}
            <a
              rel="noopener noreferrer"
              target="_blank"
              href="https://www.rarerecruitment.co.uk/privacy-policy"
            >
              Privacy Policy
            </a>{" "}
            and{" "}
            <a
              rel="noopener noreferrer"
              target="_blank"
              href="https://www.rarerecruitment.co.uk/website-terms-of-use"
            >
              Terms Of Use.
            </a>
          </p>
        )
      }
    }

    if (role) {
      const roleConfiguration = getFormConfigurationFromRole(role)
      showApplicationDeadlineInOverview = shouldNotHideItem(
        roleConfiguration,
        "showApplicationDeadlineInOverview"
      )
    }

    const tokens = []
    if (role && isLateralMode()) {
      if (showDepartment && role.department) {
        tokens.push(role.department.value)
      }
      if (role.employmentType) {
        tokens.push(role.employmentType.value)
      }
      if (role.locations && role.locations.length > 0) {
        tokens.push(role.locations.map(x => x.value).join(", "))
      }
    }

    let buttonName = `Apply`
    const query = getQueryParameters(this.props.location)
    if (query.agentId) {
      buttonName = "Submit application"
    }

    const noindex =
      (this.state.errorModalOpen ||
        NO_CRAWL_URLS.find(x => x.indexOf(window.location.hostname) !== -1)) &&
      `noindex`

    const title = `${role?.value} | ${organization?.name} | Apply`
    const url = `${organization?.subdomain}/apply/${this.props.match.params.roleId}`

    const languages = []
    if (role?.languageFields.length > 0) {
      const languagesSupported = getLanguageSupported(this.props.organization)
      languages.push({ id: "", value: ENGLISH_LANGUAGE_NAME })
      role.languageFields
        .filter(x => x.languageCode)
        .forEach(lang => {
          if (languagesSupported.find(x => x.code === lang.languageCode)) {
            languages.push({
              id: lang.languageCode,
              value: languagesSupported.find(x => x.code === lang.languageCode)
                .name,
            })
          }
        })
    }

    return infoLoading ? (
      <AppLoader />
    ) : (
      <ThemeProvider theme={theme}>
        <MuiThemeProvider theme={muitheme}>
          <Helmet>
            <title>{title}</title>
            <meta name="title" property="og:title" content={title} />
            <meta name="type" property="og:type" content={`website`} />
            <meta name="url" property="og:url" content={url} />
            <meta
              name="description"
              property="og:description"
              content={overview}
            />
            <meta name="robots" content={noindex} data-react-helmet="true" />
          </Helmet>
          <ErrorModal
            align="left"
            title={"APPLICATIONS FOR THIS OPPORTUNITY ARE NOW CLOSED."}
            onClose={this.closeErrorModal}
            isModalOpen={this.state.errorModalOpen}
            message={``}
          />
          {isPreviewMode && (
            <PreviewModeBanner languageList={languages} query={query} />
          )}
          <TitleWrapper>
            <TitleText>{role && role.value}</TitleText>
          </TitleWrapper>

          {tokens && tokens.length > 0 && (
            <DataRow>
              {tokens.map(x => {
                return <DataItem>{x}</DataItem>
              })}
            </DataRow>
          )}
          {selectedTabIndex === 0 ? (
            <Overview>
              <Text
                dangerouslySetInnerHTML={{
                  __html:
                    overview &&
                    overview.replace(
                      /<p>/g,
                      `<p style='margin-top: 0px; margin-bottom: 0px'/>`
                    ),
                }}
              />
              {role.roleDeadline && showApplicationDeadlineInOverview && (
                <DeadlineWrapper>
                  <b>Application deadline:</b>
                  <br />
                  {getDateTimeWithUTCOffset(role.roleDeadline)}
                </DeadlineWrapper>
              )}
              {role.attachments.map(attachment => (
                <DownloadItem>
                  Download&nbsp;
                  <a
                    href={attachment.url}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    {attachment.name}
                  </a>
                </DownloadItem>
              ))}
              <OverviewButtonContainer>
                <Button
                  id="applyButton"
                  label={buttonName}
                  onClick={ev => this.handleTabChange(ev, 1)}
                  type={"button"}
                  tabIndex="0"
                />
              </OverviewButtonContainer>
            </Overview>
          ) : (
            <TwoUpWrapper showRegister={showRegister}>
              <Wrapper>
                <FormWrapper>
                  <FormHeader>
                    <Translate>{headerLogin}</Translate>
                  </FormHeader>

                  <FormRow>
                    <InputField
                      id={"email"}
                      type={"email"}
                      shrink
                      placeholder={"Email address"}
                      onChange={this.handleChange}
                      label={"Email address"}
                      error={missingLoginEmail || invalidLoginEmail}
                      errorMessage={
                        missingLoginEmail ? "Required" : "Invalid email"
                      }
                      onEnter={() => {
                        if (password && email) {
                          this.loginAction()
                        }
                      }}
                    />
                  </FormRow>
                  <FormRow>
                    <InputField
                      id={"password"}
                      shrink
                      placeholder={"Password"}
                      onChange={this.handleChange}
                      onEnter={() => {
                        if (password && email) {
                          this.loginAction()
                        }
                      }}
                      label={"Password"}
                      type={"password"}
                      error={missingLoginPassword}
                      errorMessage={"Required"}
                    />
                  </FormRow>

                  <FormFooter>
                    <Button
                      id="loginButton"
                      label={"Login"}
                      disabled={errorLoginBoolean}
                      loading={loading}
                      onClick={this.loginAction}
                      type={"button"}
                    />
                    <TextButton
                      label={"Forgot password"}
                      onClick={this.goToForgotPassword}
                    />
                    {/* <TextButton
                  label={"Continue as guest"}
                  onClick={this.continueAsGuest}
                /> */}
                  </FormFooter>
                </FormWrapper>
              </Wrapper>

              {showRegister && (
                <React.Fragment>
                  <Divider />
                  <Wrapper>
                    <FormWrapper>
                      <FormHeader>
                        <Translate>{headerCreate}</Translate>
                        <TooltipInternational
                          translationMap={this.props.translationMap}
                          tooltipId={`${accountType.toLowerCase()}info`}
                        />
                      </FormHeader>

                      <FormRow>
                        <InputField
                          id={"remail"}
                          type={"email"}
                          shrink
                          placeholder={"Email address"}
                          onChange={this.handleChange}
                          label={
                            "Personal email address - not a university or school email"
                          }
                          error={missingRegisterEmail || invalidRegisterEmail}
                          errorMessage={
                            missingRegisterEmail ? "Required" : "Invalid email"
                          }
                        />
                      </FormRow>
                      <FormRow>
                        <InputField
                          shrink
                          placeholder={"Your password"}
                          value={rpassword || ""}
                          success={isPassword(rpassword)}
                          successMessage="Looks good"
                          id={"rpassword"}
                          onChange={this.handleChange}
                          label={"Create password"}
                          error={
                            missingRegisterPassword || invalidRegisterPassword
                          }
                          errorMessage={
                            missingRegisterPassword
                              ? "Required"
                              : "Invalid password"
                          }
                          hint={
                            "Passwords must be at least 8 characters long and include at least 1 uppercase letter, 1 lowercase letter, 1 number and a special character."
                          }
                          hintSmall
                          type={"password"}
                        />
                      </FormRow>

                      <FormRow>
                        <InputField
                          shrink
                          placeholder={"Confirm your password"}
                          value={rcpassword || ""}
                          success={rcpassword && rcpassword === rpassword}
                          successMessage={"It's a match!"}
                          error={
                            missingConfirmPassword || noneMatchingPasswords
                          }
                          errorMessage={
                            missingConfirmPassword
                              ? "Required"
                              : "Passwords don't match"
                          }
                          id={"rcpassword"}
                          onChange={this.handleChange}
                          label={"Confirm password"}
                          type={"password"}
                        />
                      </FormRow>

                      <FormRowFooter>
                        <CheckboxField
                          id={"agreeToTerms"}
                          checked={agreeToTerms === true}
                          error={missingAgree}
                          errorMessage={"Required"}
                          onChange={this.handleCheckboxChange}
                          label={agreeTerms}
                          translate={false}
                          value={agreeToTerms || ""}
                        />
                      </FormRowFooter>

                      <Recaptcha
                        ref={ref => (this.recaptcha = ref)}
                        sitekey={RECAPTCHA_SITEKEY}
                        locale={query.language || ENGLISH_LANGUAGE_CODE}
                        onResolved={this.onResolved}
                      />

                      <FormFooter>
                        <Button
                          id="registerButton"
                          label={"Register"}
                          disabled={errorRegisterBoolean}
                          loading={loading}
                          onClick={this.signupAction}
                          type={"button"}
                        />
                      </FormFooter>
                    </FormWrapper>
                  </Wrapper>
                </React.Fragment>
              )}
              {isProfileMode() ? <ReportIssue /> : null}
            </TwoUpWrapper>
          )}
        </MuiThemeProvider>
      </ThemeProvider>
    )
  }
}

export default AnonymousApplyPortal
